import React from 'react'
import RecruiterConfigComponent from '../Components/RecruiterConfigComponent'

function RecruiterConfigByAdminPage() {
  return (
    <div>
      <RecruiterConfigComponent />
    </div>
  )
}

export default RecruiterConfigByAdminPage